import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const CustomerList = lazy(() => import('../Pages/CustomerList'));
const AddCustomer = lazy(() => import('../Pages/AddCustomer'));
const EditCustomer = lazy(() => import('../Pages/EditCustomer'));
const CustomerView = lazy(() => import('../Pages/CustomerView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/customer.scss';

function CustomerRoute() {
  const history = useHistory();
  return (
    <Switch>
      <Route
        exact
        path="/:lng/user/customer"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <CustomerList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <CustomerList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin']}>
            <Suspense fallback={<Loading />}>
              <AddCustomer history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin']}>
            <Suspense fallback={<Loading />}>
              <EditCustomer history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <CustomerView history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default CustomerRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
